import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "d-row" }
const _hoisted_2 = { class: "buttons" }

import TileCard from '@/components/util/TileCard.vue';
import ServiceTeamTable from '@/components/service_teams/ServiceTeamTable.vue';
import ServiceTeam from '@/components/service_teams/ServiceTeam.vue';
import { useServiceTeamsStore } from "@/stores/serviceTeams";
import { reactive, onMounted, ref } from 'vue';
import { ServiceTeamItem } from '@/services/entities/ServiceTeams/ServiceTeamItem';
import CreateTeamModal from '@/components/service_teams/dialogs/CreateTeamModal.vue'
import { ServiceItem } from '@/services/entities/ServiceItem';
import { useVfm } from "vue-final-modal";


export default /*@__PURE__*/_defineComponent({
  __name: 'ServiceTeamsView',
  setup(__props) {

const createTeamModalId = Symbol("createTeamModalId");
const vfm = useVfm();
const teamsStore = useServiceTeamsStore();
const props = reactive({
    team: null as  ServiceTeamItem | null,
    newTeam: {service: { } as ServiceItem } as  ServiceTeamItem,
    teamChange: false,
});

onMounted(async () => {
    console.log(props.team);
    await teamsStore.loadServiceTeams();
});

function displayTeamDetail(teamId: string) {
    teamsStore.getServiceTeams.forEach(team => {
        if (team.id === teamId) {
            props.team = team;
        }
    });    
}

async function onCreateNewTeam() {
    console.log(props.newTeam);
    vfm.close(createTeamModalId);
    teamsStore.createServiceTeam(props.newTeam);
    await teamsStore.loadServiceTeams();    
}

function closeCreateTeam() {
    vfm.close(createTeamModalId);
}

async function reload(teamId: string) {
    props.team = null;
    await teamsStore.loadServiceTeams();
}

function onCreateTeamClick() {
    console.log("clickin for new");
    vfm.open(createTeamModalId);
}

return (_ctx: any,_cache: any) => {
  const _component_Button = _resolveComponent("Button")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(TileCard, {
        class: "tile-card",
        loaded: _unref(teamsStore).isLoaded
      }, {
        body: _withCtx(() => [
          _createVNode(ServiceTeamTable, {
            data: _unref(teamsStore).getServiceTeams,
            onDetail: displayTeamDetail
          }, null, 8, ["data"])
        ]),
        footer: _withCtx(() => [
          _createElementVNode("div", _hoisted_2, [
            _createVNode(_component_Button, {
              class: "accent",
              onClick: onCreateTeamClick
            }, {
              default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
                _createElementVNode("b", null, "+", -1),
                _createTextVNode("Create Team ", -1)
              ]))]),
              _: 1
            })
          ])
        ]),
        _: 1
      }, 8, ["loaded"]),
      _createVNode(TileCard, { class: "tile-card" }, {
        body: _withCtx(() => [
          (props.team)
            ? (_openBlock(), _createBlock(ServiceTeam, {
                key: 0,
                team: props.team,
                changed: props.teamChange,
                onReload: reload
              }, null, 8, ["team", "changed"]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      })
    ]),
    _createVNode(CreateTeamModal, {
      team: props.newTeam,
      "modal-id": _unref(createTeamModalId),
      onClose: closeCreateTeam,
      onCreate: onCreateNewTeam
    }, null, 8, ["team", "modal-id"])
  ], 64))
}
}

})